class RetailPaymentService {
    #cashQoreAxiosInstance;

    constructor(cashQoreAxiosInstance) {
        if (!cashQoreAxiosInstance) {
            throw new Error('Axios instance is required');
        }
        this.#cashQoreAxiosInstance = cashQoreAxiosInstance;
    }

    /**
     * Retrieves RefundReasons from the Cash Qore API.
     * 
     * @returns {Promise<{refundReasonId: number, reason: string, isActive: boolean, isInternal: boolean, notesRequired: boolean, stripeReason: string, description: string}[]}>>}
     */
    getRetailPaymentRefundReasons() {
        return this.#cashQoreAxiosInstance.get('/getRetailPaymentRefundReasons');
    }

    /**
     * Creates a refund for a retail payment.
     * 
     * @param {Object} refund - The refund object containing details for the refund.
     * @param {string} refund.retailPaymentId - The ID of the retail payment.
     * @param {number} refund.refundAmount - The amount to be refunded.
     * @param {number} refund.refundReasonId - The ID of the refund reason.
     * @param {string} refund.refundUser - The email of the user issuing the refund.
     * @param {string} refund.refundUserIP - The IP address of the user issuing the refund.
     * @param {string} refund.refundNote - A note explaining the refund.
     * 
     * @returns {Promise<Object>} - A promise resolving to the response from the API.
     */
    createRetailPaymentRefund(refund) {
        return this.#cashQoreAxiosInstance.post('/createRetailPaymentRefund', refund);
    }

    /**
     * Cancels a retail payment.
     * 
     * @param {Object} cancelPayment - The object containing details for the cancellation.
     * 
     * @returns {Promise<Object>} - A promise resolving to the response from the API.
     */
    cancelRetailPayment(cancelPayment) {
        return this.#cashQoreAxiosInstance.post('/cancelRetailPayment', cancelPayment); 
    }

   /**
   * Send a Retail Payment Receipt via SMS or Email to customer using the transaction id.
   * 
   * @param {string} notificationType The type of notification to send, either 'sms' or 'email'.
   * @param {string} phoneNumber The phone number to send the SMS notification to (required if notificationType is 'sms').
   * @param {string} customerEmail The email address to send the email notification to (required if notificationType is 'email').
   * @param {number} transactionId The primary identifier for the retail payment.
   * 
   * @returns {Promise<{
   *  data: { 
   *    data: {
   *        message: string,
   *    }
   *  }
   * }>} A promise that resolves with the response data.
   */
  sendRetailPaymentReceipt(paymentReceipt) {
    const customerEmail = paymentReceipt?.email;
    const notificationType = paymentReceipt?.notificationType;

    console.log("Sending Retail Payment Receipt with values: ", paymentReceipt);
    console.log("notification Type: ", notificationType);

    //Only supports "sms" | "email" for now
    if (!['sms', 'email'].includes(paymentReceipt?.notificationType)) {
      throw new Error('Invalid notification type. Supported types are "sms" or "email".');
    }

    if (notificationType === 'sms' && !paymentReceipt?.phoneNumber) {
      throw new Error('Phone number is required for SMS notifications.');
    }else if (notificationType === 'email' && !customerEmail){
      throw new Error('Customer email is required for email notifications.');
    }

    return this.#cashQoreAxiosInstance.post('/sendRetailPaymentReceipt', paymentReceipt);
  }
}

export default RetailPaymentService;
